import { createValidator } from 'util/validation'

import { AvaliacaoFormModel } from '../AvaliacaoForm'

// O validator estah vazio porque o atendimento de procedimentos nao possui a Avaliacao do SOAP
export const avaliacaoProcedimentosValidator = () => createValidator<AvaliacaoFormModel>({})
